import { render, staticRenderFns } from "./NuevoPedido.vue?vue&type=template&id=1068c0f0&"
import script from "./NuevoPedido.vue?vue&type=script&lang=js&"
export * from "./NuevoPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports